// feedbackApi.ts
import axios from '../api/axiosSetup3';

interface FeedbackPayload {
    message: string;
    rating?: number;
    email?: string;
    name?: string;
    data?: Record<string, any>;
}

const submitFeedback = async (
    feedback: FeedbackPayload
): Promise<boolean> => {
    try {
        const response = await axios.post(
            '/rpc/sf_feedback',
            feedback, {
                headers: {
                    'Accept-Profile': 'public', // schema                    
                    'Content-Profile': 'public', // schema
                }        
            }
        );
        return response.status === 204;
    } catch (error) {
        console.error('Failed to submit feedback:', error);
        return false;
    }
};

export const feedbackApi = { 
    submitFeedback 
};